<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="91" height="100" viewBox="0 0 91 100">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" fill-rule="nonzero">
        <g>
          <g>
            <path
              d="M.216 0v99.643h90.609V0H.216zM84.27 6.556V22.8H6.772V6.556h77.497zM6.772 44.577V29.356h51.532v15.221H6.772zm17.771 6.555v16.93H6.772v-16.93h17.771zm6.556 0h53.17v16.93h-53.17v-16.93zm33.76-6.555V29.356h19.41v15.221h-19.41zM6.771 93.086V74.618h77.497V93.09H6.772v-.003z"
              transform="translate(-752 -318) translate(254 212) translate(498 106)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
